
(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldLatLong', fbFieldLatLongDirective);

    function fbFieldLatLongDirective(lodash) {
        return {
            restrict: "EA",
            scope: {
                element: '=',
                model: '='
            },
            controller: fbFieldLatLongDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/libraries/formBuilder/fields/fieldLatLong',
            link: fbFieldLatLongDirectiveLink
        };

        function fbFieldLatLongDirectiveLink(scope, elem) {

            const vm = scope.vm;
            if (lodash.has(vm.element, 'attr.attributes')) {
                if (!lodash.isEmpty(vm.element, 'attr.attributes')) {
                    const inputElem = elem.find('input');
                    lodash.forIn(vm.element.attr.attributes, (value, attr) => {
                        inputElem.attr(attr, value);
                    });
                }
            }
        }
    }

    function fbFieldLatLongDirectiveCtrl(FormBuilderService, $scope, lodash) {
        var vm = this;


        this.$onInit = function() {
            var formIdentifier = $scope.$parent.vm.formIdentifier;
            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);

            vm.getType = function() {
                switch (vm.element.type) {
                    case 'smart-text-element':
                    case 'lat-long':
                        return 'text';
                    default:
                        return vm.element.type;
                }
            };

            vm.resetLatLong = resetLatLong;
            vm.setGmapUrl = setGmapUrl;
            vm.onLatLongSearchChange = onLatLongSearchChange;
            vm.gmapQueryParams = {
                key: 'AIzaSyCPvURq8GmCmsIxyg7_CkOyhYaWvkaCNDA',
                q: 'Singapore',
            };

            vm.setGmapUrl();

            $scope.$watch('vm.model', function () {
                vm.searchModel = vm.model;
                vm.onLatLongSearchChange();
            });
        }


        function onLatLongSearchChange() {
            if (lodash.isEmpty(vm.searchModel) || vm.searchModel.trim().length === 0) return;

            vm.gmapQueryParams = Object.assign(vm.gmapQueryParams, {
                q: vm.searchModel
                    .split(' ')
                    .reduce(function (accum, justWord) {
                        return accum.concat([justWord.trim()])
                    }, [])
                    .join('+'),
            });
            vm.setGmapUrl();
            vm.model = vm.searchModel.trim();
        };

        function setGmapUrl() {
            var baseUrl = 'https://www.google.com/maps/embed/v1/place';

            var queryParams = Object.keys(vm.gmapQueryParams)
                .reduce(function (accum, queryParamKey) {
                    var queryparam = vm.gmapQueryParams[queryParamKey];
                    return accum.concat([[queryParamKey, queryparam].join('=')]);
                }, [])
                .join('&');

            vm.gmapUrl = baseUrl + '?' + queryParams;
        }

        function resetLatLong() {
            Object.assign(vm.gmapQueryParams, {
                q: 'Singapore',
            });

            vm.model = null;
            vm.searchModel = null;
            vm.setGmapUrl();

        }
    }
})();
